const path = location.pathname.replace(/\/$/, '');
const isSalePage = path.startsWith('/pages/sale-');
const isDownloadPage = path.startsWith('/pages/download');
const isHelpPage = path.startsWith('/pages/help');
const isProjectsPage = path.startsWith('/pages/projects');

if (isDownloadPage) downloadApp();

document.addEventListener('DOMContentLoaded', () => {
    initPageProtection();
    // initNavActive();

    if (isSalePage) {
        initWechatFeatures();
        initMapFeatures();
    }

    if (!isHelpPage && !isDownloadPage && !isHelpPage) initContentPopup();
    if (isProjectsPage) initVideoPlay();

});


function initPageProtection() {
    // document.addEventListener('contextmenu', e => e.preventDefault());
    
    document.addEventListener('dragstart', e => e.preventDefault());
    
    const qrcode = document.getElementById('wechatInfo');
    if (qrcode) {
        qrcode.addEventListener('contextmenu', e => {
        e.stopPropagation();
        });
    }
    document.addEventListener('keydown', e => {
        if (
        (e.ctrlKey && ["u", "s", "p"].includes(e.key.toLowerCase())) ||
        e.key === "PrintScreen"
        ) {
        e.preventDefault();
        }
    });

    const video = document.querySelectorAll('video');
    video.forEach(v => {
        v.addEventListener('contextmenu', e => e.preventDefault());
        v.addEventListener('dragstart', e => e.preventDefault());
    });

    const emeProtection = () => {
    if (typeof MediaKeys !== 'undefined') {
        document.addEventListener('keydown', (e) => {
        if (e.key === 'PrintScreen') {
            e.preventDefault(); 
        }
        else if (e.key === 'r' && e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        });
    }
    };

    emeProtection();

    window.addEventListener('beforeprint', e => {
        showToast("Printing is disabled");
        e.preventDefault();
    });
}

function initWechatFeatures() {
  const showBtn = document.getElementById('showWechatBtn');
  const wechat = document.getElementById('wechatContainer');
  const copyBtn = document.getElementById('copyBtn');
  const wechatId = document.getElementById('wechatId');
  const iconX = document.getElementById('icon-x');

  if (!showBtn || !wechat) {
    // console.warn('WeChat elements not found');
    return;
  }

  showBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    wechat.style.display = wechat.style.display === 'none' ? 'block' : 'none';
  });

  copyBtn?.addEventListener('click', (e) => {
    e.stopPropagation(); 
    navigator.clipboard.writeText(wechatId.innerText).then(() => {
      showToast('Copied!');
    });
  });

  iconX?.addEventListener('click', (e) => {
    wechat.style.display = 'none';
  });

  wechat.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  document.addEventListener('click', () => {
    wechat.style.display = 'none';
  });
}

async function initMapFeatures() {
  const mapFrame = document.getElementById('mapFrame');
  const iframe = document.getElementById('mapIframe');
  const btn = document.getElementById('mapBtn');
  
  if (!mapFrame || !iframe || !btn) {
    // console.warn('Map elements not found');
    return;
  }

  const btnText = btn.querySelector('span.font-x');
  const googlePosition = mapFrame.dataset.position || "113.19871,23.08485";

  let countryCode = null;
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    countryCode = (data.country_code || '').toUpperCase();
    // console.log('Detected country:', countryCode);
  } catch (err) {
    // console.warn("IP detection failed, fallback to Google Maps:", err);
  }

  iframe.src = countryCode === 'CN' 
    ? `https://uri.amap.com/marker?position=113.19871,23.08485&name=${encodeURIComponent(googlePosition)}&src=huiqifountain.com&callnative=0`
    : `https://www.google.com/maps?q=${encodeURIComponent(googlePosition)}&output=embed`;

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    mapFrame.classList.toggle('show');
    mapFrame.classList.toggle('hidden');

    const isShown = mapFrame.classList.contains('show');
    btnText.textContent = isShown ? 'Hide Map' : 'View Map';
    btn.classList.toggle('active', isShown);
  });

  mapFrame.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  document.addEventListener('click', () => {
    if (mapFrame.classList.contains('show')) {
      mapFrame.classList.remove('show');
      mapFrame.classList.add('hidden');
      btn.classList.remove('active');
      btnText.textContent = 'View Map';
    }
  });
}

function showToast(message) {
  const toast = document.createElement('div');
  toast.textContent = message;
  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '50px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'rgba(0,0,0,0.75)',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '14px',
    opacity: '0',
    transition: 'opacity 0.4s ease',
    zIndex: '9999',
  });
  
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      toast.remove();
    }, 400);
  }, 2000);
}

function getDeviceType() {
    const ua = navigator.userAgent;
    const platform = navigator.platform;
    const touch = navigator.maxTouchPoints || 0;
    
    if (/Android/i.test(ua)) return 'Android';
    if (/iPhone|iPod/i.test(ua)) return 'iOS';
    if (/iPad/i.test(ua) || (platform === 'MacIntel' && touch > 1)) return 'iOS';
    if (/Win/i.test(platform) || /Windows/i.test(ua)) return 'Windows';
    if (/Mac/i.test(platform)) return 'Mac';
    if (/Linux/i.test(platform)) return 'Linux';

    return 'Other';
}

function downloadApp() {
    const device = getDeviceType();
    const mainContent = document.getElementById("MainContent");
    const ahref = document.createElement('a');
    ahref.classList.add('absolute-center');
    mainContent.appendChild(ahref);

    const i18n = {
        zh: {
            clickText: "手动点击下载",
        },
        en: {
            clickText: "Click to Download Manually",
        }
    }

    let localang = localStorage.getItem('lang');

    const lang = navigator.language.startsWith('zh') ? "zh" : "en";
    // localStorage.setItem('lang', lang);
    // localang = lang;


    const androidUrl = "https://cdn.shopify.com/s/files/1/0603/0721/0303/files/H52CE3BA0__20251112232201.apk";
    const iosUrl = "https://play.google.com/store/search?q=tiktok&c=apps";
    const fallbackUrl = "https://cdn.shopify.com/s/files/1/0603/0721/0303/files/H52CE3BA0__20251112232201.apk";

    let target = fallbackUrl

    if (device === 'Android') target = androidUrl;
    if (device === 'iOS') target = iosUrl;

    ahref.href = target;
    ahref.textContent = i18n[lang].clickText;

    location.href = target;
}

function initContentPopup() {
    'use strict';

    const NS = 'cf-';
    const overlayId = NS + 'overlay';
    const closeBtnId = NS + 'close-btn';
    const formId = NS + 'user-form';
    const nameInputId = NS + 'name';
    const emailInputId = NS + 'email';
    const phoneInputId = NS + 'phone';
    const messageInputId = NS + 'message';
    const messageAreaId = NS + 'message-area';

    const config = {
        modalDelay: 30000,
        preventRepeatHours: 1, 
        submitEndpoint: '/contact'
    };

    const STORAGE_KEY = NS + 'last-shown-time';

    function showMessage(message, type = 'success', autoHide = true) {
        const messageArea = document.getElementById(messageAreaId);
        if (!messageArea) return;
        
        const messageText = messageArea.querySelector(`.${NS}message-text`);
        if (!messageText) return;
        
        messageArea.classList.remove(NS + 'success', NS + 'error', NS + 'warning');
        
        messageArea.classList.add(NS + type, NS + 'show');
        messageText.textContent = message;
        
        if (autoHide) {
            setTimeout(() => hideMessage(), type === 'success' ? 1000 : 2000);
        }
    }

    function hideMessage() {
        const messageArea = document.getElementById(messageAreaId);
        if (messageArea) {
            messageArea.classList.remove(NS + 'show');
            setTimeout(() => {
                messageArea.classList.remove(NS + 'success', NS + 'error', NS + 'warning');
            }, 300);
        }
    }

    function shouldShowModal() {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return true;
        }

        if (isSalePage) {
            return false;
        }

        try {
            const lastShownTime = localStorage.getItem(STORAGE_KEY);
            if (!lastShownTime) return true;
            
            const hoursPassed = (Date.now() - parseInt(lastShownTime, 10)) / (1000 * 60 * 60);
            return hoursPassed >= config.preventRepeatHours;
        } catch (e) {
            return true;
        }
    }

    function recordModalShown() {
        try {
            localStorage.setItem(STORAGE_KEY, Date.now().toString());
        } catch (e) {
            console.warn('Could not record modal shown time:', e);
        }
    }

    function validateForm(name, email, phone, message) {
        if (!name || !email || !phone || !message) {
            showMessage('Please fill in all required fields!', 'error');
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showMessage('Please enter a valid email address!', 'error');
            return false;
        }

        const phoneRegex = /^[\d\s\-\+\(\)]{10,}$/;
        if (!phoneRegex.test(phone)) {
            showMessage('Please enter a valid phone number!', 'error');
            return false;
        }

        if (message.length < 10) {
            showMessage('Please enter a message with at least 10 characters!', 'error');
            return false;
        }

        return true;
    }

    async function submitForm(formData) {
        try {
            const response = await fetch(config.submitEndpoint, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                const contentType = response.headers.get('content-type');
                
                if (contentType && contentType.includes('application/json')) {
                    const result = await response.json();
                    return { success: !result.errors, errors: result.errors };
                } else {
                    const text = await response.text();
                    return { 
                        success: text.includes('success') || 
                                text.includes('thank') || 
                                !text.includes('error')
                    };
                }
            } else {
                throw new Error(`Server responded with status: ${response.status}`);
            }
        } catch (error) {
            throw error;
        }
    }

    function initModalHandlers() {
        const closeModalBtn = document.getElementById(closeBtnId);
        const modalOverlay = document.getElementById(overlayId);
        const userForm = document.getElementById(formId);
        
        if (!closeModalBtn || !modalOverlay || !userForm) {
            // console.error('Required form elements not found');
            return;
        }
        
        setTimeout(() => {
            const overlay = document.getElementById(overlayId);
            if (overlay && shouldShowModal()) {
                overlay.classList.add(NS + 'active');
                recordModalShown();
            }
        }, config.modalDelay);
        
        closeModalBtn.addEventListener('click', () => {
            modalOverlay.classList.remove(NS + 'active');
        });
        
        modalOverlay.addEventListener('click', (e) => {
            if (e.target === modalOverlay) {
                modalOverlay.classList.remove(NS + 'active');
            }
        });
        
        const messageCloseBtn = document.querySelector(`.${NS}message-close`);
        if (messageCloseBtn) {
            messageCloseBtn.addEventListener('click', hideMessage);
        }
        
        userForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            const nameInput = document.getElementById(nameInputId);
            const emailInput = document.getElementById(emailInputId);
            const phoneInput = document.getElementById(phoneInputId);
            const messageInput = document.getElementById(messageInputId);
            const submitBtn = userForm.querySelector(`.${NS}submit-btn`);
            
            if (!nameInput || !emailInput || !phoneInput || !messageInput || !submitBtn) return;
            
            const name = nameInput.value.trim();
            const email = emailInput.value.trim();
            const phone = phoneInput.value.trim();
            const message = messageInput.value.trim();
            
            if (!validateForm(name, email, phone, message)) {
                return;
            }
            
            const originalBtnText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';
            
            try {
                const formData = new FormData();
                formData.append('form_type', 'contact');
                formData.append('utf8', '✓');
                formData.append('contact[name]', name);
                formData.append('contact[email]', email);
                formData.append('contact[phone]', phone);
                formData.append('contact[body]', message);
                
                const csrfToken = document.querySelector('meta[name="csrf-token"]') || 
                                document.querySelector('meta[name="authenticity-token"]') ||
                                document.querySelector('input[name="authenticity_token"]');
                
                if (csrfToken) {
                    const tokenValue = csrfToken.getAttribute ? 
                        csrfToken.getAttribute('content') : 
                        csrfToken.value;
                    if (tokenValue) {
                        formData.append('authenticity_token', tokenValue);
                    }
                }
                
                const result = await submitForm(formData);
                
                if (result.success) {
                    showMessage('Thank you for your message! We will get back to you soon.', 'success');
                    userForm.reset();
                    
                    setTimeout(() => {
                        modalOverlay.classList.remove(NS + 'active');
                    }, 2000);
                } else {
                    const errorMsg = result.errors ? 
                        (Array.isArray(result.errors) ? result.errors.join(', ') : result.errors) :
                        'Submission failed. Please try again.';
                    throw new Error(errorMsg);
                }
            } catch (error) {
                // console.error('Form submission error:', error);
                showMessage(
                    error.message || 'Failed to submit form. Please try again later.', 
                    'error'
                );
            } finally {
               
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }
            }
        });
        
        const inputs = document.querySelectorAll(`#${formId} input, #${formId} textarea`);
        inputs.forEach(input => {
            input.addEventListener('focus', function() {
                this.classList.add(NS + 'focused');
            });
            
            input.addEventListener('blur', function() {
                this.classList.remove(NS + 'focused');
                if (this.value.trim()) this.classList.add(NS + 'filled');
                else this.classList.remove(NS + 'filled');
            });
        });
    }

    function initContactForm() {
        
        const existingOverlay = document.getElementById(overlayId);
        if (existingOverlay && existingOverlay.dataset.initialized === 'true') {
            return;
        }
        
        const overlay = document.getElementById(overlayId);
        if (!overlay) {
            // console.warn('Contact form: Overlay element missing. Contact form module skipped safely.');
            return;
        }
        
        overlay.dataset.initialized = 'true';
        
        setTimeout(initModalHandlers, 100);
    }

    initContactForm();
    
    if (typeof window !== 'undefined') {
        window.contactFormCleanup = function() {
            const overlay = document.getElementById(overlayId);
            if (overlay) {
                overlay.classList.remove(NS + 'active');
                overlay.dataset.initialized = 'false';
            }
        };
        
        window.contactFormReset = function() {
            try {
                localStorage.removeItem(STORAGE_KEY);
                // console.log('Contact form reset successfully');
            } catch (e) {
                console.warn('Could not reset contact form:', e);
            }
        };
    }     
}

function initVideoPlay() {
    const videos = document.querySelectorAll('video');

    const obs = new IntersectionObserver((e, observer) => {
        e.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.play();
            } else {
                entry.target.pause();
            }
        });
    }, {threshold: 0.3});

    videos.forEach(v => {
        obs.observe(v);
    });
}

function initNavActive() {

    const nav = document.querySelector('.header-menu-nav');
    const items = nav.querySelectorAll('.first-level-item');
    const node = items[1];
    const first = node.querySelector('a');
    const currentPath = location.pathname;

    if (currentPath.startsWith("/pages/projects")) {
        items[2].classList.add("text-primary");

    } else if (currentPath.startsWith("/pages/about")) {
        items[3].classList.add("text-primary");

    } else if (currentPath.startsWith("/pages/contact")) {
        items[4].classList.add("text-primary");

    } else if (currentPath.startsWith("/collections") || currentPath.startsWith("/products")) {
        first.classList.add("text-primary");

    } else {
        items[0].classList.add("text-primary");
    }
    
    if (!nav) return;

}
